import { backofficeRequest } from '../../../axios'

export const getLettersHistory = async ({
  page = 1,
  rowsPerPage = 25,
  searchValue = '',
  status = '',
  endDate = '',
  startDate = '',
}) => {
  try {
    const { data } = await backofficeRequest.get('backoffice/letters', {
      params: {
        page: page,
        per: rowsPerPage,
        search: searchValue,
        status,
        endDate,
        startDate,
      },
    })
    return data
  } catch (error) {
    return error
  }
}

export const getLettersStatuses = async () => {
  try {
    const { data } = await backofficeRequest.get('backoffice/letters/statuses')
    return data
  } catch (error) {
    return error
  }
}
